export default "<p>\r\n  success-snack-bar works!\r\n</p>\r\n";